import {
  type ActiveFilterValues,
  type SearchSortByValues,
  type SearchSuggestionOption,
  SortByValues,
  type YouMightBeIntoPillAttributes,
} from './types';

import { SupportedLocation } from '@/modules/location/constants';

export const SEARCH_ID_STORAGE_KEY = 'optimistic_search_uuid';
export const INITIAL_FILTER_STATE: ActiveFilterValues = {
  activeGroup: '',
  activeProductTypes: [],
  activeSizeIds: [],
  activeBrandIds: [],
  activePrice: {
    max: null,
    min: null,
  },
  activeGender: '',
  activeColours: [],
  activeConditions: [],
  isKids: false,
  isOnSale: false,
  sortBy: SortByValues.Relevance,
};

export const ITEMS_PER_PAGE = 24;

export const SEARCH_RESULTS_STALE_TIME = 5 * 60 * 1000;

export const SORT_BY_OPTIONS: { id: SearchSortByValues; name: string }[] = [
  {
    id: SortByValues.Relevance,
    name: 'Sorting.Relevance',
  },
  {
    id: SortByValues.PriceLowToHigh,
    name: 'Sorting.PriceAscending',
  },
  {
    id: SortByValues.PriceHighToLow,
    name: 'Sorting.PriceDescending',
  },
  {
    id: SortByValues.NewlyListed,
    name: 'Sorting.NewlyListed',
  },
];

export const TRENDING_SEARCHES_SUGGESTIONS: Record<
  string,
  SearchSuggestionOption[]
> = {
  [SupportedLocation.US]: [
    { label: 'lululemon define jacket', value: 'lululemon define jacket' },
    { label: 'baggy jeans', value: 'baggy jeans' },
    { label: 'carhartt jacket', value: 'carhartt jacket' },
    { label: 'essentials hoodie', value: 'essentials hoodie' },
    { label: 'vintage t shirt', value: 'vintage t shirt' },
  ],
  [SupportedLocation.GB]: [
    { label: 'carhartt jacket', value: 'carhartt jacket' },
    { label: 'ralph lauren quarter zip', value: 'ralph lauren quarter zip' },
    { label: 'baggy jeans', value: 'baggy jeans' },
    { label: 'north face puffer', value: 'north face puffer' },
    { label: 'leather jacket', value: 'leather jacket' },
  ],
  [SupportedLocation.AU]: [
    { label: 'kookai', value: 'kookai' },
    { label: 'sabbi', value: 'sabbi' },
    { label: 'dissh', value: 'dissh' },
    { label: 'aje', value: 'aje' },
    { label: 'gorman', value: 'gorman' },
  ],
};

export const EBAY_LANDING_BLENDED_PILLS: YouMightBeIntoPillAttributes[] = [
  {
    label: 'Vintage graphic T-shirt',
    href: '/search/?q=vintage+graphic+t-shirt',
  },
  { label: 'Baggy jeans', href: '/search/?q=baggy+jeans' },
  { label: 'Birkenstock sandals', href: '/search/?q=sandals&brands=353' },
  { label: 'JanSport backpack', href: '/search/?q=backpack&brands=1620' },
  { label: 'Babydoll top', href: '/search/?q=babydoll+top' },
  {
    label: 'Adidas sweatpants',
    href: '/search/?q=sweatpants&brands=151%2C315',
  },
  {
    label: 'Vivienne Westwood bag',
    href: '/search/?q=bag&brands=230&groups=accessories&gender=female&productTypes=bag',
  },
  { label: 'Salomon XTs', href: '/search/?q=xts&brands=1679' },
  {
    label: 'Reformation mini dress',
    href: '/search/?q=mini+dress&brands=433%2C23646',
  },
  { label: `Levi's 501`, href: '/search/?q=501+jeans&brands=31' },
  { label: 'Ray-Ban sunglasses', href: '/search/?q=sunglasses&brands=512' },
  { label: 'Farm Rio dress', href: '/search/?q=dress&brands=14092' },
];
